import { MenuItem, TextField } from "@mui/material";
import React, { useState } from "react";
import {
  FlexCenter,
  FlexLeftCenter,
  FlexRowEnd,
  FlexRowSB,
} from "../../../../constant/CustomeStyle";
import ImageUpload from "../AddProduct//ImageUpload";

const EditProduct = (props) => {
  const {
    values: { Name },
    errors,
    touched,
    handleSubmit,
    handleChange,
    isValid,
    setFieldTouched,
    setFieldValue,
  } = props;

  const groupCodes = ["Beef", "Beef 2", "Beef 3"];

  const [groupCode, setGroupCode] = useState(groupCodes[0]);
  const handleGroupCode = (e) => {
    setGroupCode(e.target.value);
  };

  const tagLists = ["Tag", "Tag 2", "Tag 3"];

  const [tagOption, setTagOption] = useState(tagLists[0]);
  const handleTag = (e) => {
    setTagOption(e.target.value);
  };

  const [portions, setPortions] = useState([]);
  const addPortion = () => {
    setPortions([...portions, 1]);
  };

  const deletePortion = () => {
    let newA = [...portions];
    newA.splice(0, 1);
    setPortions(newA);
  };

  return (
    <div
      style={{
        marginTop: 20,
        width: 702,
      }}
    >
      <form>
        <FlexRowSB>
          <InputBoxN title={"Product Name"} isPortion={false} />
          <InputBoxDropdown
            title={"Group Code"}
            handleChange={handleGroupCode}
            itemLists={groupCodes}
            currentValue={groupCode}
          />
        </FlexRowSB>

        <FlexRowSB style={{ marginTop: 10 }}>
          <InputBoxDropdown
            title={"Tag"}
            handleChange={handleTag}
            itemLists={tagLists}
            currentValue={tagOption}
          />

          <InputBoxN title={"Barcode"} isPortion={false} />
        </FlexRowSB>

        {portions.map((portion, index) => (
          <FlexRowSB style={{ marginTop: 10 }} key={index}>
            <InputBoxN
              title={`Portion ${index + 1}`}
              isPortion={true}
              deletePortion={deletePortion}
            />
            <InputBoxN
              title={"Product Price"}
              isPortion={true}
              deletePortion={deletePortion}
            />
          </FlexRowSB>
        ))}

        <AddPortionBtn addPortion={addPortion} />

        <div>
          <ImageUpload />
        </div>

        <FlexCenter style={{ marginTop: 20 }}>
          <FlexCenter
            style={{
              width: 302,
              height: 48,
              borderRadius: 4,
              background: "#52BD9A",
              cursor: "pointer",
              fontSize: 18,
              fontFamily: "Poppins, sans-serif",
              fontWeight: "500",
              color: "#FFF",
            }}
          >
            Save Product
          </FlexCenter>
        </FlexCenter>
      </form>
    </div>
  );
};

const InputBoxDropdown = ({ title, handleChange, itemLists, currentValue }) => (
  <div style={{ width: 340 }}>
    <div
      style={{
        textAlign: "left",
        marginBottom: 5,
        fontSize: 16,
        fontFamily: "Poppins, sans-serif",
        color: "#1D1D1D",
      }}
    >
      {title}
    </div>
    <TextField
      // id="outlined-select-currency"
      select
      value={currentValue}
      onChange={handleChange}
      fullWidth
      InputProps={{
        style: {
          height: 48,
          background: "#FFF",
          border: "1px solid #CFCFCF",
          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.188)",
          borderRadius: 2,
          textAlign: "left",
        },
      }}
    >
      {itemLists.map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </TextField>
  </div>
);

const InputBoxN = ({ title, isPortion, deletePortion }) => (
  <div style={{ width: 340 }}>
    <FlexLeftCenter style={{ textAlign: "left", marginBottom: 5 }}>
      <div
        style={{
          fontSize: 16,
          fontFamily: "Poppins, sans-serif",
          color: "#1D1D1D",
        }}
      >
        {title}
      </div>
      {isPortion && <DeletePortionBtn deletePortion={deletePortion} />}
    </FlexLeftCenter>
    <TextField
      id="outlined-basic"
      variant="outlined"
      fullWidth
      InputProps={{
        style: {
          height: 48,
          background: "#FFF",
          border: "1px solid #CFCFCF",
          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.188)",
          borderRadius: 2,
        },
      }}
    />
  </div>
);

const AddPortionBtn = ({ addPortion }) => (
  <FlexRowEnd style={{ marginTop: 15 }}>
    <FlexCenter
      style={{
        width: 82,
        height: 20,
        fontSize: 12,
        fontFamily: "Poppins, sans-serif",
        fontWeight: "500",
        color: "#FFF",
        background: "#333C4B",
        borderRadius: 4,
        cursor: "pointer",
      }}
      onClick={addPortion}
    >
      Add Portion
    </FlexCenter>
  </FlexRowEnd>
);

const DeletePortionBtn = ({ deletePortion }) => (
  <FlexRowEnd style={{ marginLeft: 15 }}>
    <FlexCenter
      style={{
        width: 102,
        height: 20,
        fontSize: 12,
        fontFamily: "Poppins, sans-serif",
        fontWeight: "500",
        color: "#FFF",
        background: "#C4C4C4",
        borderRadius: 4,
        cursor: "pointer",
      }}
      onClick={deletePortion}
    >
      Delete Portion
    </FlexCenter>
  </FlexRowEnd>
);

export default EditProduct;
